import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { MailButton } from "@/components/contacting/Buttons";
import { PhoneCTA } from "@/components/contacting/Buttons/PhoneButton";
import { useI18n } from "@/shared/hooks";
import { useContactCardSection } from "@/contexts/contact";
import { useIsNewBuildProject } from "@/shared/hooks/useIsNewBuildProject/useIsNewBuildProject";
export const ContactExtraSlide = () => {
    var _a;
    const { t } = useI18n();
    const { phoneNumbers = [] } = (_a = useContactCardSection()) !== null && _a !== void 0 ? _a : {};
    const isProject = useIsNewBuildProject();
    const testId = "cdp-gallery-images";
    const titleText = isProject
        ? t("pdpSeeker_gallery_title")
        : t("gallery.image.last.title");
    return (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "spacing.16", margin: "0 auto", width: "sizing.328", height: "sizing.200", gap: "spacing.12", children: [_jsx(Box, { typography: "typography.headline.22.bold", color: "color.content.default.inverted.default", textAlign: "center", marginBottom: "spacing.24", children: titleText }), _jsx(MailButton, { av_zone: "gallery_CTA_last_slide", legacyTrackingInfos: "gallery_CTA_last_slide", rootTestId: testId }), _jsx(PhoneCTA, { rootTestId: testId, phoneNumbers: phoneNumbers, showModal: true, variant: "secondary-inverted", legacyTrackingInfos: "gallery_CTA_last_slide", trackingAvZone: "gallery_CTA_last_slide", children: t("contact.card.show_phone") })] }));
};
